/* Futuristic layer: theme switch (Harvest / Dark), cursor spotlight, 3D card tilt. Respects reduced motion. */
(function(){
  var root=document.documentElement;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=window.matchMedia&&matchMedia('(pointer:fine)').matches;
  function cur(){return root.dataset.gt==='dark'?'dark':'harvest'}
  var sw;
  function paint(){if(!sw)return;var c=cur();sw.dataset.on=c;sw.querySelectorAll('button').forEach(function(b){b.setAttribute('aria-pressed',b.dataset.v===c?'true':'false')})}
  function set(v){root.dataset.gt=v;try{localStorage.setItem('gt',v)}catch(e){}paint()}
  function toggle(){
    sw=document.createElement('div');sw.className='gt-switch';sw.setAttribute('role','group');sw.setAttribute('aria-label','Color theme');
    sw.innerHTML='<span class="gt-switch__pill"></span>'+
      '<button type="button" data-v="harvest"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2.4M12 19.1v2.4M2.5 12h2.4M19.1 12h2.4M5.3 5.3l1.7 1.7M17 17l1.7 1.7M18.7 5.3L17 7M7 17l-1.7 1.7"/></svg>Harvest</button>'+
      '<button type="button" data-v="dark"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 14.5A8.5 8.5 0 019.5 4 8.5 8.5 0 1020 14.5z"/></svg>Dark</button>';
    sw.addEventListener('click',function(e){var b=e.target.closest('button');if(b)set(b.dataset.v)});
    document.body.appendChild(sw);paint();
  }
  function spot(){
    if(reduce||!fine)return;
    var s=document.createElement('div');s.className='gt-spot';document.body.appendChild(s);
    var x=0,y=0,t=false;
    addEventListener('pointermove',function(e){x=e.clientX;y=e.clientY;if(!t){t=true;requestAnimationFrame(function(){s.style.setProperty('--mx',x+'px');s.style.setProperty('--my',y+'px');t=false})}},{passive:true});
  }
  function tilt(){
    if(reduce||!fine)return;
    var sel='.e-games a,product-card .product-card__content,.gst__item,.apple-steps__card';
    document.addEventListener('pointermove',function(e){
      var el=e.target.closest&&e.target.closest(sel);
      if(!el)return;
      var r=el.getBoundingClientRect(),px=(e.clientX-r.left)/r.width-.5,py=(e.clientY-r.top)/r.height-.5;
      el.style.setProperty('--ry',(px*8).toFixed(2)+'deg');el.style.setProperty('--rx',(-py*8).toFixed(2)+'deg');
      el.style.setProperty('--gx',((px+.5)*100).toFixed(0)+'%');el.style.setProperty('--gy',((py+.5)*100).toFixed(0)+'%');
    },{passive:true});
    document.addEventListener('pointerout',function(e){
      var el=e.target.closest&&e.target.closest(sel);
      if(el&&!el.contains(e.relatedTarget)){el.style.removeProperty('--rx');el.style.removeProperty('--ry')}
    });
  }
  function init(){toggle();spot();tilt()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();